import classNames from "classnames";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

import Input from "../Input";
import ShareSocials from "../ShareSocials";
import QR from "../QR";
import { Button } from "../Button";

import { XL } from "@const/breakpoints";
import { useService } from "@/base/hooks/useService";
import { copyToClipboard } from "@helpers/share";
import { ToasterService } from "@services/ToastService";
import { ReactComponent as IconLink } from "../../assets/ic-link.svg";

import styles from "./index.module.scss";

const ShareFooter = ({
  shareLink,
  withBody,
  withQrCode,
  message,
  type,
  postUniqueKey,
  streamUniqueKey,
  subscriptionUniqueKey,
  username,
  contentOwnerKey,
}) => {
  const { t } = useTranslation("common");

  const isDesktop = useMediaQuery({
    query: `(min-width: ${XL})`,
  });

  const toasterService = useService(ToasterService);

  const handleCopyLink = () => {
    copyToClipboard(shareLink);
    toasterService.success(t("LINK_COPIED"));
  };

  if (withQrCode) {
    return (
      <div className="d-flex flex-xl-row flex-column justify-content-between">
        <div className="d-flex flex-column align-items-center">
          <div className="d-flex w-100">
            <Input value={shareLink} notEditable className={styles.input} />

            <Button
              size="sm"
              onClick={handleCopyLink}
              data-small={!withBody}
              className={classNames(
                "d-flex align-items-center justify-content-center d-xl-none",
                styles.copyMob,
              )}
            >
              <span className="text-primary text-body-1">{t("COPY")}</span>
            </Button>
          </div>

          <Button
            size="lg"
            onClick={handleCopyLink}
            data-small={!withBody}
            className={classNames(
              "d-flex align-items-center justify-content-center w-100 flex-shrink-0 d-none d-xl-flex",
              styles.copyForCreator,
            )}
          >
            <IconLink className="me-2 d-none d-xl-block text-primary" />
            <span className="text-primary text-body-2">{t("COPY_LINK")}</span>
          </Button>

          <ShareSocials
            message={message}
            username={username}
            postUniqueKey={postUniqueKey}
            streamUniqueKey={streamUniqueKey}
            subscriptionUniqueKey={subscriptionUniqueKey}
            type={type}
          />
        </div>

        {isDesktop ? (
          <div className={styles.verticalSeparator} />
        ) : (
          <div className={styles.horizontalSeparator} />
        )}

        <QR shareLink={shareLink} username={username} />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex w-100">
        <Input value={shareLink} notEditable className={styles.input} />

        <Button
          size="sm"
          onClick={handleCopyLink}
          data-small={!withBody}
          className={classNames(
            "d-flex align-items-center justify-content-center d-xl-none",
            styles.copyMob,
          )}
        >
          <span className="text-primary text-body-1">{t("COPY")}</span>
        </Button>
      </div>

      <div
        className={classNames(
          "d-flex flex-row w-100 align-items-center justify-content-between",
          styles.copyContainer,
        )}
      >
        <Button
          size="lg"
          onClick={handleCopyLink}
          data-small={!withBody}
          className={classNames(
            "d-flex align-items-center justify-content-center flex-shrink-0 d-none d-xl-flex",
            styles.copy,
          )}
        >
          <IconLink className="me-2 d-none d-xl-block text-primary" />
          <span className="text-primary text-body-2">{t("COPY_LINK")}</span>
        </Button>
        <span
          className={classNames(
            "mt-2 mb-2 mt-xl-0 mb-xl-0 text-primary text-body-1 d-none d-xl-flex",
            styles.or,
          )}
        >
          {t("OR")}
        </span>
        <ShareSocials
          message={message}
          username={username}
          postUniqueKey={postUniqueKey}
          streamUniqueKey={streamUniqueKey}
          contentOwnerKey={contentOwnerKey}
          subscriptionUniqueKey={subscriptionUniqueKey}
          type={type}
        />
      </div>
    </div>
  );
};

export default ShareFooter;
